<template>
  <div class="evangelie">
    <div ref="overlay" class="overlay align-middle text-center" v-show="isBusy">
      <b-spinner style="font-size: 1rem; width: 12rem; height: 12rem; position: absolute; left: calc(50% - 6rem); top: 9rem;" />
      <font-awesome-icon :icon="['fas', 'church']" />
    </div>
    <div ref="content" class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    busy: 0,
    loadersCount: 0,
    refreshTokenPeriod: 60000
  }),
  computed: {
    ...mapState('ParishModule', {
      currentParish: state => state.current
    }),
    locale () {
      return this.$store.getters['UserModule/locale']
    },
    isBusy () {
      return this.loadersCount > 0
    }
  },
  watch: {
    isBusy (busy) {
      if (busy) {
        this.showOverlay()
      } else {
        this.hideOverlay()
      }
    }
  },
  mounted () {
    this.checkAuth()
  },
  beforeCreate () {
    window.addEventListener('keyup', (event) => {
      if (event.ctrlKey && event.code === 'Enter') {
        this.showEditor()
      }
    })
  },
  created () {
    this.$events.$on('busy', () => {
      this.loadersCount++
    })
    this.$events.$on('idle', () => {
      this.loadersCount--
      if (this.loadersCount < 0) {
        this.loadersCount = 0
      }
    })
  },
  methods: {
    showEditor () {
      let text = ''
      if (window.getSelection) {
        text = window.getSelection().toString()
      } else if (document.selection && document.selection.type !== 'Control') {
        text = document.selection.createRange().text
      }

      if (text) {
        alert(`Вы выделили текст "${text}"`)
      }
    },
    async checkAuth () {
      this.showOverlay()
      try {
        await this.$store.dispatch('AuthModule/refreshToken')
        await this.$store.dispatch('UserModule/loadProfile')
        // await this.$store.dispatch('UserModule/setLocale', this.locale)
        await this.$store.dispatch('ParishModule/loadParishesList')
        await this.$store.dispatch('ChatModule/connect')
        await this.$store.dispatch('ChatModule/notifications', this.currentParish)
      } catch (error) {
        // пользователь не авторизован
      } finally {
        await this.$store.dispatch('UserModule/setLocale', this.locale)
      }
      this.hideOverlay()
    },
    showOverlay () {
      this.$refs.overlay.style.display = 'block'
      this.$refs.content.style.filter = 'blur(5px)'
    },
    hideOverlay () {
      this.$refs.overlay.style.display = 'none'
      this.$refs.content.style.filter = 'none'
    }
  }
}
</script>

<style lang="scss">
$font-family-base: 'Resavska BG Sans';
$font-family-headers: 'Resavska BG Sans', sans-serif;

$primary: rgb(128, 109, 101);
$secondary: rgb(113, 98, 111);

$enable-rounded: false;
$enable-responsive-font-sizes: true;

@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';

@import '/fonts/resavska/stylesheet.css';
@import 'assets/bootstrap-social.css';

@mixin btn-social($color-bg) {
  @include button-variant($color-bg, darken($color-bg, 10%));
}
.btn-facebook { @include btn-social(#3b5998); }
.btn-odnoklassniki { @include btn-social(#f4731c); }
.btn-twitter { @include btn-social(#55acee); }
.btn-vk { @include btn-social(#587ea3); }
.btn-whatsapp { @include btn-social(#25D366); }
.btn-viber { @include btn-social(#665CAC); }
.btn-skype { @include btn-social(#00AFF0); }
.btn-telegram { @include btn-social(#0088cc); }
.btn-link2 { @include btn-social(#888888); }

h1, h2, h3 {
  font-family: $font-family-headers;
}

.navbar-toggler {
  color: rgb(255,255,255);
}
.transparent {
  background-color: rgba(248, 215, 218, .6);
}
.toast-body {
  text-align: center;
}
.hidden {
  display: none;
}
.cursor {
  cursor: pointer;
}
.hover:hover {
  text-decoration: underline;
}
.smaller {
  font-size: 90%;
}

.overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAG0lEQVQYV2NkYGD4z8DAwMgABXAGNgGwSgwVAFbmAgXQdISfAAAAAElFTkSuQmCC) repeat;
  background-color: rgba($primary, .5);
  z-index: 65000;
  cursor: progress;
  color: $secondary;
  font-size: 6rem;

  padding-top: 10rem;

  .spinner-border {
    animation-duration: 1.2s;
  }
}

#content {
  flex-grow: 1;
  padding-bottom: 2rem;
}
.evangelie {
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;

  background-color: rgb(240, 240, 240);

  fieldset {
    &.form-group > div[role="group"] {
      width: 100%;
    }
  }

  .breadcrumb {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.125);
  }
}

.fade-leave-active {
  display: none;
}
.fade-enter-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.locale-switcher {
  position: absolute;
  right: 0;
  padding-right: 15px;
}

.nav-tabs {
  .nav-item {
    /*&:first-child {*/
    /*  .nav-link {*/
    /*    margin-left: 0;*/
    /*  }*/
    /*}*/
    /*&:last-child {*/
    /*  .nav-link {*/
    /*    margin-right: 0;*/
    /*  }*/
    /*}*/

    .nav-link {
      /*background-color: rgb(245, 245, 245);*/
      /*border-color: #dee2e6 #dee2e6 #fff;*/

      border: none;
      border-bottom: 2px solid transparent;

      /*padding: .5rem .25rem;*/
      /*margin: 0 .75rem;*/

      &:hover {
        border-bottom-color: #806d65;
      }

      &.active {
        font-weight: bold;
        background-color: inherit;

        color: #565270;
        border-bottom-color: #565270;
      }
    }
  }
}

figure {
  &.image-style-align-left {
    float: left;
  }
  &.image-style-align-right {
    float: right;
  }
  &.image {
    padding: .5rem;
    text-align: center;
    display: block;
    margin: 0 auto;
    img {
      max-width: 100%;
    }
    &.image-style-align-right {
      padding-right: 0;
    }
    &.image-style-align-left {
      padding-left: 0;
    }
  }
}

@media (min-width: 992px) {
  .main-menu {
    .navbar-brand {
      display: none;
    }
  }
}
@media (max-width: 1200px) {
  .badge {
    white-space: normal;
  }
}
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
}
@media (max-width: 576px) {
  html {
    font-size: 12px;
  }
}
</style>
